import IconButtonMUI from './IconButtonMUI';

export default IconButtonMUI;
